
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"information(3)","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 13.317 13.317"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 7009","d":"M6.659 0a6.659 6.659 0 106.659 6.659A6.666 6.666 0 006.659 0zm0 12.106a5.448 5.448 0 115.448-5.448 5.454 5.454 0 01-5.448 5.448z","fill":"#1c1c1c"}}),_c('path',{attrs:{"data-name":"Path 7010","d":"M6.659 2.872a.709.709 0 10.709.709.71.71 0 00-.709-.709z","fill":"#1c1c1c"}}),_c('path',{attrs:{"data-name":"Path 7011","d":"M6.659 6.043a.532.532 0 00-.532.532v3.19a.532.532 0 001.063 0v-3.19a.532.532 0 00-.531-.532z","fill":"#1c1c1c"}})])
          )
        }
      }
    